// extracted by mini-css-extract-plugin
module.exports = {"side-menu":"side-menu--1kl9t","button":"button--pJsbY","icon":"icon--1ivNs","-open":"-open--3zNaE","description":"description--2uM0W","-active":"-active--w3CHp"};